var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModernaCasaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.39062,
    y: 6.52539,
    width: 1.66538,
    height: 6.50858,
    rx: 0.832691,
    transform: "rotate(-31.9221 7.39062 6.52539)",
    fill: "white",
    fillOpacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.35352,
    y: 1.80273,
    width: 1.66538,
    height: 6.50858,
    rx: 0.832691,
    transform: "rotate(-31.9221 8.35352 1.80273)",
    fill: "white",
    fillOpacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0488281,
    y: 1.00977,
    width: 1.66538,
    height: 16.6028,
    rx: 0.832691,
    transform: "rotate(-31.9221 0.0488281 1.00977)",
    fill: "white",
    fillOpacity: 0.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3457,
    y: 12.873,
    width: 1.66538,
    height: 4.07628,
    rx: 0.832691,
    transform: "rotate(-31.9221 11.3457 12.873)",
    fill: "white",
    fillOpacity: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3047,
    y: 8.14844,
    width: 1.66538,
    height: 9.87333,
    rx: 0.832691,
    transform: "rotate(-31.9221 12.3047 8.14844)",
    fill: "white",
    fillOpacity: 0.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.16797,
    y: 4.56445,
    width: 1.66538,
    height: 1.64839,
    rx: 0.824194,
    transform: "rotate(-31.9221 6.16797 4.56445)",
    fill: "white",
    fillOpacity: 0.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModernaCasaLogo);
export default __webpack_public_path__ + "static/media/moderna-casa-logo.f64ee1e7c938b16c520d271b0468abf8.svg";
export { ForwardRef as ReactComponent };